import { useReviewFeature } from '../hooks/use-review-feature';
export const useGetBatchModePermissions = () => {
  const {
    acceptRejectLabel,
    enableCommentsFeedback,
    canEdit
  } = useReviewFeature();
  return {
    canTakeActions: false,
    //TODO: add support for take actions in batch mode
    isEditable: canEdit,
    canComment: enableCommentsFeedback
  };
};